import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import Button from 'components/common/Button'
import { showPhoneFieldSelector, showPhoneCodeFieldSelector, isLoginContainerSelector } from 'src/selectors'
import { showPhoneCodeField, notIsLoginContainer, showPhoneField, hidePhoneCodeField } from 'src/actions/timepoll'
import { fetchContactMethod } from 'src/actions'

import { routerActions } from 'react-router-redux'

import inputStyles from 'src/styles/inputs.css'

import styles from './phone-confirmation.scss'

class PhoneConfirmation extends React.Component {
  _setConfirmationCode = (event) => {
    const { updateForm } = this.props
    const value = event.target.value
    updateForm({
      confirmationCode: value,
      confirmationCodeValid: 'unknown'
    })
  }

  _onSubmit = (event) => {
    const {
      onSubmitConfirmation,
      onNotIsLoginContainer,
      updateForm,
      onUpdateScreen
    } = this.props
    event.preventDefault()
    const { confirmationCode } = this.props.loginForm
    if (confirmationCode.length === 6) {
      onSubmitConfirmation(confirmationCode)
      onNotIsLoginContainer()
      // onShowPhoneField()
      // onHideConfirmationCodeForm()
      onUpdateScreen()
    }
    updateForm({ formattedPhoneNumber: '' })
  }

  _validateConfirmationCode () {
    const { confirmationCode } = this.props.loginForm

    return !(confirmationCode.length === 6)
  }

  render () {
    const {
      loginForm,
      onResendCode,
      transparent
    } = this.props
    const { confirmationCode, confirmationCodeValid } = loginForm

    const inputValidClass = confirmationCodeValid ? null : (transparent ? styles['error-transparent'] : styles.error)
    const inputClass = transparent ? 'transparent-text-input' : 'text-input'

    return (
      <form className={styles['form']}>
        <div className={styles['name-fields']}>
          <input
            autoFocus
            type='tel'
            autoComplete='off'
            className={classnames(inputValidClass, inputStyles[inputClass], styles['code-input'])}
            placeholder='Phone Code'
            value={confirmationCode}
            onChange={this._setConfirmationCode}
          />
          <a className={styles['action-link']} onClick={onResendCode}>Resend Code</a>
        </div>
        <div className={styles['button-wrapper']}>
          <Button disabled={this._validateConfirmationCode()} className={styles['button']} onClick={this._onSubmit}>
            next
          </Button>
        </div>
        <input style={{ display: 'none' }} type='submit' />
      </form>
    )
  }
}

PhoneConfirmation.propTypes = {
  loginForm: PropTypes.object.isRequired,
  onSubmitConfirmation: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired,
  transparent: PropTypes.bool,
  onNotIsLoginContainer: PropTypes.func,
  onUpdateScreen: PropTypes.func
}

function mapStateToProps (state) {
  const showPhoneCodeField = showPhoneCodeFieldSelector(state)
  const showPhoneField = showPhoneFieldSelector(state)
  const isLoginContainer = isLoginContainerSelector(state)
  return {
    showPhoneCodeField,
    showPhoneField,
    isLoginContainer
  }
}
function mapDispatchToProps (dispatch) {
  const onShowPhoneCodeField = () => dispatch(showPhoneCodeField())
  const onNotIsLoginContainer = () => dispatch(notIsLoginContainer())
  const onShowPhoneField = (param) => dispatch(showPhoneField(param))
  const onHideConfirmationCodeForm = () => dispatch(hidePhoneCodeField())
  return {
    onShowPhoneCodeField,
    onNotIsLoginContainer,
    onShowPhoneField,
    onHideConfirmationCodeForm,
    goBack: () => dispatch(routerActions.goBack()),
    onUpdateScreen: (params) => dispatch(fetchContactMethod(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneConfirmation)



// WEBPACK FOOTER //
// ./src/containers/time-poll/components/PhoneConfirmation.jsx